import * as React from "react";
import { HouseholdInfo } from "../patient-portal/HouseholdInfo";
import HouseholdDetails from "./HouseholdDetails";

export default function HouseholdInformationPanel({
  title,
  householdInformation,
}: {
  title: string;
  householdInformation?: HouseholdInfo;
}) {
  return (
    <div className="panel household-information-panel">
      <div className="panel-title h-flex space-between no-wrap">
        <div>{title}</div>
      </div>
      {householdInformation ? (
        <HouseholdDetails householdInfo={householdInformation} />
      ) : (
        <div className="centered">
          <span className="no-information-message">
            {i18n["Page.Patient.FullDetails.Information.NotFilled"]}
          </span>
        </div>
      )}
    </div>
  );
}
